import React, { Component } from 'react';
import FullPageLoader from '../Loader/FullPageLoader';
import Loader from '../Loader/Loader';
import axios from 'axios';
import Header from '../Header/Header';
import baseUrl from '../baseUrl';
// const baseUrl = "http://api.encabook999.com:4000/api";
class Binary extends Component {
  constructor(props) {
    super(props);
    var accessToken = localStorage.getItem('token');
    this.state = {
      accessToken: accessToken,
      BinaryDetail: [],
      isLoding: false,
    };
  }
  componentDidMount() {
    this.callBinaryTable();
  }
  callBinaryTable = () => {
    this.setState({ isLoding: true });
    let headers = {
      Authorization: 'Bearer ' + this.state.accessToken,
    };
    axios.get(baseUrl + '/binarybetlistuser', { headers }).then((resp) => {
      if (resp.data) {
        this.setState({ BinaryDetail: resp.data.data[0], isLoding: false });
      } else {
        this.setState({ isLoding: false });
      }
    });
  };
  render() {
    const { BinaryDetail, isLoding } = this.state;
    return (
      <div className="w-100">
        <Header />
        <div id="wrapper">
          {this.state.isLoading ? <FullPageLoader /> : null}

          <div className="container-fluid">
            <h5 className="text-dark mt-5">
              <i className="fas fa-th-list mr-3" />
              Binary Bet List
            </h5>

            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th scope="col">
                      {' '}
                      <span>Event Type</span>
                    </th>
                    <th scope="col">
                      {' '}
                      <span>Event Name</span>
                    </th>
                    <th scope="col">
                      <span>User Name</span>
                    </th>
                    <th scope="col">
                      <span>Runner Name</span>
                    </th>
                    <th scope="col">
                      {' '}
                      <span>Odd</span>
                    </th>
                    {/* <th scope="col">
                      {" "}
                      <span>Type</span>
                    </th> */}
                    <th scope="col">
                      {' '}
                      <span>Stack</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {!isLoding ? (
                    BinaryDetail && BinaryDetail.length ? (
                      BinaryDetail.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <h6>
                                {item.event_type ? item.event_type : null}
                              </h6>
                            </td>
                            <td>
                              <div>
                                {item.event_name ? item.event_name : null}
                              </div>
                            </td>
                            <td>
                              <div>
                                {item.user_id && item.user_id.username
                                  ? item.user_id.username
                                  : '-'}
                              </div>
                            </td>
                            <td>
                              <div>{item.team_name ? item.team_name : '-'}</div>
                            </td>
                            <td>
                              <div>{item.odds ? item.odds : '-'}</div>
                            </td>
                            {/* <td>
                              <div>{item.type ? item.type : "-"}</div>
                            </td> */}
                            <td>
                              <div>{item.stake ? item.stake : '-'}</div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8">
                          <h4 className="text-center">Not Found</h4>
                        </td>
                      </tr>
                    )
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        <Loader />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Binary;



// WEBPACK FOOTER //
// ./src/components/HomePage/Binary.js